import styled from '@appbaseio/vue-emotion';

const InputWrapper = styled('div')`
  flex: 1;
  position: relative;
`;

export default InputWrapper;
